module.exports = __webpack_public_path__ + "static/media/Bambino.458fd3b0.ttf";